module.exports = __webpack_public_path__ + "img/cover.d1892266.png";